// extracted by mini-css-extract-plugin
module.exports = {"marker_bold":"terms_marker_bold___hAgn","table":"terms_table__8sCap"};